import { Button } from "@mui/material";
import thankyouImages from "../../assests/images/thank_you.png";
import React from "react";
import { useNavigate } from "react-router-dom";

function Thankyou() {
  let navigate = useNavigate();
  const navigateUrl = (url) => {
    navigate(url);
  }
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="thankyou">
          <div className="thnk_img">
            <img src={thankyouImages} alt="" />
          </div>

          <h4 className="you_panel_react">Thank You!</h4>

          <h5 className="onboarding_status_react_thankyou">
            Your Onboarding details have been submitted successfully.
          </h5>

          <div className="vendor_panel_btn_thankyou">
            <Button className="view_details_you" onClick={() => window.location.reload()}>View Details</Button>
            <Button className="view_progress_you" onClick={() => navigateUrl('/admin/onboarding-form-status')}>View Progress</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Thankyou;
